export const alphaNumericSort = (elem1: string, elem2: string) => {
    return elem1.localeCompare(elem2, undefined, { numeric: true, sensitivity: 'base' });
};

export const isEmail = (email: string) => {
    return email.match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
};
